import logo from './logo.svg';
import './App.css';
import PointingPizza from './pointing-pizza-production';

function App() {
  return (
    <PointingPizza />
  );
}

export default App;
